import { render, staticRenderFns } from "./RecordedSearchMenu.vue?vue&type=template&id=397c2d52"
import script from "./RecordedSearchMenu.vue?vue&type=script&lang=ts"
export * from "./RecordedSearchMenu.vue?vue&type=script&lang=ts"
import style0 from "./RecordedSearchMenu.vue?vue&type=style&index=0&id=397c2d52&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports